import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import CarrierActionableFilterPill from '../../../../../components/actionable-filter-pill/connected/shipping/carrier';
import messages from './messages';

export default {
  id: 'carrier',
  displayName: <FormattedMessage {...messages.carrier} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'CarrierId',
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER, criteriaInformations, existingFiltersHelpers);
  },
  actionableFilterPill: CarrierActionableFilterPill,
  allowsMultipleSelection: true,
};
